/**
 * Phase B — small reassurance badge shown near a form's submit button on
 * offline-capable mobile features. Tells field staff it's safe to fill the
 * form without signal, and switches to an active state when actually offline.
 */
import React, { useEffect, useState } from 'react';
import { Cloud, CloudOff } from 'lucide-react';

export default function OfflineReadyBadge({ className = '' }) {
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  return (
    <span
      data-testid="offline-ready-badge"
      className={`inline-flex items-center gap-1 text-[10px] font-display font-bold uppercase tracking-wider px-2 py-1 rounded-full border ${
        online
          ? 'bg-slate-50 text-slate-500 border-slate-200'
          : 'bg-amber-100 text-amber-800 border-amber-300'
      } ${className}`}
    >
      {online ? <Cloud size={11} /> : <CloudOff size={11} />}
      {online ? 'Works offline' : 'Offline — will sync'}
    </span>
  );
}
